import { createSelector } from "reselect";
import _ from "lodash";

const createSelectors = (parentReducer) => {
    return new (class {
        selectAllToolboxes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackToolboxTalkWidget_reducer"];

            return reducer.toolbox;
        };

        selectProfile = (store) => {
            const reducer = store["UserProfile_reducer"];
            let userInfo = reducer.user;
            return userInfo.profile;
        };

        selectDept = createSelector(
            [this.selectProfile],

            (profile = false) => {
                if (profile) {
                    // userDepts = profile.departments
                    return profile.departments;
                } else return null;
            }
        );
        selectAreas = createSelector(
            [this.selectProfile],
            (profile = false) => {
                if (profile) {
                    // userAreas = profile.areas
                    return profile.areas;
                } else return null;
            }
        );
        selectToolboxTalks = createSelector(
            [this.selectAllToolboxes],
            (toolboxes = false) => {
                if (toolboxes) {
                    let toolboxInfo = _.compact(
                        Object.keys(toolboxes).map((e) => {
                            let uid = e;
                            let profile =
                                _.get(toolboxes[e], "profile") || "N/A";

                            return { uid, profile };
                        })
                    );
                    return toolboxInfo.sort((a, b) =>
                        a.profile.toolbox_topic.localeCompare(
                            b.profile.toolbox_topic
                        )
                    );
                } else return false;
            }
        );
    })();
};

export default createSelectors;
